import { render, staticRenderFns } from "./CaseViewerHeaderTitle.vue?vue&type=template&id=60b2c4f0&scoped=true&"
import script from "./CaseViewerHeaderTitle.vue?vue&type=script&lang=js&"
export * from "./CaseViewerHeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./CaseViewerHeaderTitle.vue?vue&type=style&index=0&id=60b2c4f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b2c4f0",
  null
  
)

export default component.exports